(function () {
  'use strict';

  var checkoutPrefetched = false;

  function getDrawer() {
    return document.querySelector('[data-wevolt-cart-drawer]');
  }

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function checkoutUrl() {
    return cartRoot() + 'checkout';
  }

  function prefetchCheckout() {
    if (checkoutPrefetched) return;
    checkoutPrefetched = true;
    if (!document.head || !document.head.querySelector) return;
    if (document.head.querySelector('link[data-wevolt-checkout-prefetch]')) return;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = checkoutUrl();
    link.setAttribute('data-wevolt-checkout-prefetch', '');
    document.head.appendChild(link);
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.documentElement.classList.add('wevolt-scroll-lock');
    prefetchCheckout();
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('wevolt-scroll-lock');
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 360);
  }

  function updateCartBubbles(count) {
    if (count == null || Number.isNaN(count)) return;
    var value = String(count);
    document.querySelectorAll('.cart-bubble__text').forEach(function (el) {
      el.textContent = value;
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('cart-bubble--empty', count === 0);
    });
    document.querySelectorAll('.wig-header__cart-count').forEach(function (el) {
      el.textContent = value;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function countFromNode(node) {
    if (!node) return null;
    var attr = node.getAttribute && node.getAttribute('data-wevolt-cart-count');
    if (attr != null && attr !== '') {
      var parsed = parseInt(attr, 10);
      return Number.isNaN(parsed) ? null : parsed;
    }
    var el = node.querySelector && node.querySelector('[data-wevolt-cart-count]');
    if (!el) return null;
    var fromAttr = el.getAttribute('data-wevolt-cart-count');
    var parsedEl = parseInt(fromAttr != null ? fromAttr : el.textContent, 10);
    return Number.isNaN(parsedEl) ? null : parsedEl;
  }

  function applyDrawerHtml(html, itemCount) {
    var drawer = getDrawer();
    if (!drawer || !html) return false;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newDialog = doc.querySelector('[data-testid="cart-drawer-dialog"]');
    var currentDialog = drawer.querySelector('[data-testid="cart-drawer-dialog"]');

    if (newDialog && currentDialog) {
      currentDialog.innerHTML = newDialog.innerHTML;
      currentDialog.className = newDialog.className;
      if (newDialog.hasAttribute('data-wevolt-cart-count')) {
        currentDialog.setAttribute(
          'data-wevolt-cart-count',
          newDialog.getAttribute('data-wevolt-cart-count')
        );
      }
      bindDrawerEvents(drawer);
      var count = itemCount != null ? itemCount : countFromNode(newDialog);
      if (count != null) updateCartBubbles(count);
      return true;
    }

    return false;
  }

  function refreshDrawer(sectionId, options) {
    var drawer = getDrawer();
    if (!drawer) return Promise.resolve();

    var silent = options && options.silent;
    if (!silent) drawer.classList.add('is-updating');
    var url = cartRoot() + '?section_id=' + encodeURIComponent(sectionId);

    return fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        applyDrawerHtml(html);
      })
      .finally(function () {
        drawer.classList.remove('is-updating');
      });
  }

  function applySectionsResponse(sections, sectionId, itemCount) {
    if (!sections || !sectionId || !sections[sectionId]) return false;
    return applyDrawerHtml(sections[sectionId], itemCount);
  }

  function changeLineQuantity(lineKey, quantity) {
    var drawer = getDrawer();
    var sectionId = drawer && drawer.dataset.sectionId;
    if (!sectionId) return Promise.resolve();

    drawer.classList.add('is-updating');
    var body = {
      id: lineKey,
      quantity: Math.max(0, quantity),
      sections: sectionId,
      sections_url: cartRoot()
    };

    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function (data) {
        applySectionsResponse(data.sections, sectionId, data.item_count);
      })
      .finally(function () {
        drawer.classList.remove('is-updating');
      });
  }

  function applyDiscount(code) {
    var drawer = getDrawer();
    var sectionId = drawer && drawer.dataset.sectionId;
    if (!sectionId) return Promise.resolve();

    var errorEl = drawer.querySelector('[data-wevolt-discount-error]');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    drawer.classList.add('is-updating');
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: code,
        sections: sectionId,
        sections_url: cartRoot()
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        applySectionsResponse(data.sections, sectionId, data.item_count);
        var input = drawer.querySelector('[data-wevolt-discount-input]');
        if (input) input.value = '';
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = (err && err.description) || (err && err.message) || 'Invalid discount code';
        }
      })
      .finally(function () {
        drawer.classList.remove('is-updating');
      });
  }

  function bindDrawerEvents(drawer) {
    if (!drawer) drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('[data-wevolt-cart-close]').forEach(function (el) {
      el.onclick = closeDrawer;
    });

    drawer.querySelectorAll('[data-wevolt-qty-change]').forEach(function (btn) {
      btn.onclick = function () {
        changeLineQuantity(btn.dataset.lineKey, parseInt(btn.dataset.quantity, 10));
      };
    });

    drawer.querySelectorAll('[data-wevolt-qty-input]').forEach(function (input) {
      input.onchange = function () {
        changeLineQuantity(input.dataset.lineKey, parseInt(input.value, 10) || 0);
      };
    });

    drawer.querySelectorAll('[data-wevolt-cart-remove]').forEach(function (btn) {
      btn.onclick = function () {
        changeLineQuantity(btn.dataset.lineKey, 0);
      };
    });

    var discountBtn = drawer.querySelector('[data-wevolt-discount-apply]');
    var discountInput = drawer.querySelector('[data-wevolt-discount-input]');
    if (discountBtn && discountInput) {
      discountBtn.onclick = function () {
        var code = discountInput.value.trim();
        if (!code) return;
        applyDiscount(code);
      };
      discountInput.onkeydown = function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          discountBtn.click();
        }
      };
    }
  }

  function initDrawer() {
    var drawerRoot = getDrawer();
    if (!drawerRoot || drawerRoot.dataset.wevoltCartDrawerInit === 'true') return;
    drawerRoot.dataset.wevoltCartDrawerInit = 'true';
    bindDrawerEvents(drawerRoot);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerRoot.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  function handleCartOpen(event) {
    var drawer = getDrawer();
    if (!drawer) return;

    var detail = event && event.detail ? event.detail : {};
    if (detail.open === false) return;

    var sectionId = drawer.dataset.sectionId;
    if (detail.sections && sectionId && detail.sections[sectionId]) {
      applySectionsResponse(detail.sections, sectionId, detail.itemCount);
    } else if (detail.itemCount != null) {
      updateCartBubbles(detail.itemCount);
    }

    openDrawer();
  }

  function handleCartUpdated(event) {
    var drawer = getDrawer();
    if (!drawer || !drawer.dataset.sectionId) return;

    var detail = event && event.detail ? event.detail : {};
    var sectionId = drawer.dataset.sectionId;

    if (detail.itemCount != null) updateCartBubbles(detail.itemCount);

    if (detail.sections && detail.sections[sectionId]) {
      applySectionsResponse(detail.sections, sectionId, detail.itemCount);
    }
  }

  document.addEventListener('wevolt:cart:open', handleCartOpen);
  document.addEventListener('wevolt:cart:updated', handleCartUpdated);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-wevolt-cart-drawer]')) {
      var el = getDrawer();
      if (el) delete el.dataset.wevoltCartDrawerInit;
      initDrawer();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }

  window.wevoltCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer,
    updateBubbles: updateCartBubbles,
    applySections: function (sections, sectionId, itemCount) {
      return Promise.resolve(applySectionsResponse(sections, sectionId, itemCount));
    },
    checkoutUrl: checkoutUrl
  };
})();
